import type { IconData } from '@stacksjs/iconify-core'

export const gbSct4x3: IconData = {
  "body": "<path fill=\"#0065bd\" d=\"M0 0h640v480H0z\"/><path stroke=\"#fff\" stroke-width=\".6\" d=\"m0 0l5 3M0 3l5-3\" transform=\"scale(128 160)\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default gbSct4x3
